import { LinkListItem } from "./LinkListItem/LinkListItem";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Links.module.css";
import { useTranslation } from "@coworker/locales";
import { useCallback, useState } from "react";
import { OkCancelModal } from "@coworker/app/src/components/RoomSettings/Organisms/Modals/OkCancelModal";

type LinksProps = {
  links: string[];
};

export function Links({ links }: LinksProps) {
  const { t } = useTranslation();
  const [pendingUrl, setPendingUrl] = useState<string | null>(null);

  const handleLinkClick = useCallback((rawUrl: string) => {
    try {
      const parsed = new URL(rawUrl);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
        return;
      }
      setPendingUrl(parsed.toString());
    } catch {
      // Ignore invalid URLs
    }
  }, []);

  const handleConfirmLeave = useCallback(() => {
    if (pendingUrl) {
      window.open(pendingUrl, "_blank", "noopener,noreferrer");
    }
    setPendingUrl(null);
  }, [pendingUrl]);

  const handleCancelLeave = useCallback(() => {
    setPendingUrl(null);
  }, []);

  if (links.length === 0) {
    return null;
  }
  return (
    <div className={styles["container"]}>
      <FixaText textStyle="Heading.S">{t("linksStringCapitalized")}</FixaText>
      <div className={styles["linksWrapper"]}>
        {links.map((url) => (
          <LinkListItem key={url} url={url} onLinkClick={handleLinkClick} />
        ))}
      </div>
      {pendingUrl !== null && (
        <OkCancelModal
          onOk={handleConfirmLeave}
          onCancel={handleCancelLeave}
          title={t("leavingFixaString")}
          text={t("leavingFixaDescriptionString")}
          primaryButtonText={t("openLinkString")}
        />
      )}
    </div>
  );
}
